import { inject, Injectable, model } from '@angular/core';
import { LOCATION} from '@libs/shared/injections/window';
import { map } from 'rxjs';
import { take } from 'rxjs/operators';
import { PaymanyTypeEnum } from '@libs/enums/paymany-type.enum';
import { IFormData } from '@libs/models/models';
import { CardService } from '@libs/services/card.service';
import { LoanService } from '@libs/services/loan.service';

@Injectable()
export abstract class PaymentHelper  {
  private location = inject(LOCATION);
  private cardService = inject(CardService);
  private loanService = inject(LoanService);
  public isDisabled = model(false);

  public addCardHandler(): void {
    this.cardService
      .getRegisterData(this.location.href)
      .pipe(
        map((formData: IFormData) => formData.ipayData.url),
        take(1)
      )
      .subscribe({
        next: (url: string) => location.href = url,
        error: (error) => console.error(error)
      });
  }

  public loanPayment(id: number, amount: number): void {
    this.isDisabled.set(true);
    this.loanService
      .paymentLoan(id, amount, this.location.href, PaymanyTypeEnum.SIMPLE_PAYMENT)
      .pipe(
        map((formData: IFormData) => formData.ipayData.url),
        take(1)
      )
      .subscribe({
        next: (url: string) => location.href = url,
        error: () => this.isDisabled.set(false)
      });
  }
}
